import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {intlShape} from 'react-intl'

import {open as openAction} from './miniPlayerActions'
import {play as playAction, pause as pauseAction} from './AudioPlayer/playerActions'
import {notify as notifyAction} from '../notifier/NotifierActions'
import * as selectors from './miniPlayerSelectors'
import * as shapes from '../../constant/shapes'

import {ORIGIN_PLAYQUEUE_TYPES} from '../../components/miniPlayer/AudioPlayer/playerConstants'
import ProgressCircle from './ProgressCircle'
import GTMController from "../../utils/kpi/GTMController"

export const notificationMessage = (id, intl) => (
	<div>
		<div key="player-message-nostream">
			<div>
				{intl.formatMessage({id: 'notifications.nostream'})}
			</div>
		</div>
	</div>
)


class MiniPlayer extends Component {
	constructor(props) {
		super(props)
		this.play = this.play.bind(this)
		this.pause = this.pause.bind(this)
		this.open = this.open.bind(this)
		this.notifyClick = this.notifyClick.bind(this)
	}

	notifyClick() {
		const { notify, element } = this.props
		const { intl } = this.context
		notify({
			message: <div className="notification-content">{notificationMessage(element.albumId || element.id, intl)}</div>,
			level: 'info',
			autoDismiss: 5
		})
	}

	play() {
		this.props.play()
		return true
	}

	pause() {
		this.props.pause()
		return true
	}

	open() {
		const { open, GTMPlayEvent, element, type} = this.props
		GTMController.pushPlayEvent(GTMPlayEvent)
		open(element, type)
		return true
	}

	render() {
		const {element, buttonClassName, type, isCurrentTrack, playing, sampleable } = this.props
		if (sampleable) {
			if (isCurrentTrack(type, element.id)) {
				if (playing) {
					return (
						<div onClick={this.pause} className={`${buttonClassName} pct pct-pause`}>
							<ProgressCircle/>
							<div className="volume">
								<div className="volume__bar"/>
								<div className="volume__bar"/>
								<div className="volume__bar"/>
							</div>
						</div>
					)
				}
				return (
					<div onClick={this.play} className={`${buttonClassName} pct pct-play`}>
						<ProgressCircle/>
					</div>
				)
			}
			return (<div onClick={this.open} className={`${buttonClassName} pct pct-play`} />)
		}
		return (
			<div
				className={`${buttonClassName} pct pct-play`}
				onClick={this.notifyClick}
			/>
		)
	}
}

MiniPlayer.propTypes = {
	element: PropTypes.oneOfType([shapes.trackItem, shapes.albumCard]).isRequired,
	buttonClassName: PropTypes.string,
	type: PropTypes.oneOf([ORIGIN_PLAYQUEUE_TYPES.track, ORIGIN_PLAYQUEUE_TYPES.album]).isRequired,
	sampleable: PropTypes.bool.isRequired,
	isCurrentTrack: PropTypes.func,
	playing: PropTypes.bool,
	play: PropTypes.func,
	pause: PropTypes.func,
	open: PropTypes.func,
	notify: PropTypes.func,
	GTMPlayEvent: PropTypes.string
}

MiniPlayer.defaultProps = {
	buttonClassName: "track-player"
}

MiniPlayer.contextTypes = {
	intl: intlShape
}

const mapStateToProps = (state) => ({
	playing: selectors.isPlaying(state),
	isCurrentTrack: (type, idElement) => selectors.isCurrentTrack(state)(type, idElement)
})

const actions = {
	open: openAction,
	play: playAction,
	pause: pauseAction,
	notify: notifyAction
}

export default connect(mapStateToProps, actions)(MiniPlayer)



// WEBPACK FOOTER //
// ./src/components/miniPlayer/MiniPlayer.jsx